import * as React from 'react'
import styled from 'styled-components'
import type { TrackClipSlideType } from './TrackClip'
import { Navigation, Scrollbar, A11y, EffectFade } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { config } from 'react-awesome-styled-grid'
import TrackClip from './TrackClip'
import { LeftSliderArrow } from './shared/icons/LeftSliderArrow'
import { RightSliderArrow } from './shared/icons/RightSliderArrow'
import { colors } from '@components/shared/colors'
import { isChromeForIOs145 } from '@helpers/utils'

type PropsType = {
  slides: TrackClipSlideType[]
}

export default function TrackClipSlider (props: PropsType): React.ReactNode {
  const [currentAudio, setCurrentAudio] = React.useState(0)
  const [killAudio, setKillAudio] = React.useState(false)
  return (
    <>
      <DesktopSlider className="with-arrows">
        <ArrowWrapper className="slidePrev-btn-track-slider">
          <LeftSliderArrow color={colors.sand} />
        </ArrowWrapper>

        <Swiper
          modules={[Navigation, Scrollbar, A11y, EffectFade]}
          spaceBetween={0}
          slidesPerView={1}
          effect="fade"
          fadeEffect={{
            crossFade: true
          }}
          a11y={{
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide'
          }}
          navigation={{
            prevEl: '.slidePrev-btn-track-slider',
            nextEl: '.slideNext-btn-track-slider'
          }}
          onSlideChange={(): void => {
            setKillAudio(true)
          }}
        >
          {props.slides.length &&
            props.slides.map(
              (slide: TrackClipSlideType, index: number): React.ReactNode => {
                return (
                  <SwiperSlide key={`track-clip-slider-${index}`}>
                    <TrackClip
                      duration={slide.duration}
                      startTime={slide.startTime}
                      endTime={slide.endTime}
                      mp3Url={slide.mp3Url}
                      title={slide.title}
                      img={slide.img}
                      tags={slide.tags}
                      audioIndex={index}
                      currentAudio={currentAudio}
                      setCurrentAudio={(): void => {
                        setCurrentAudio(index)
                        setKillAudio(false)
                      }}
                      killAudio={killAudio}
                    />
                  </SwiperSlide>
                )
              }
            )}
        </Swiper>
        <ArrowWrapper className="slideNext-btn-track-slider">
          <RightSliderArrow color={colors.sand} />
        </ArrowWrapper>
      </DesktopSlider>

      <MobileSlider>
        <Swiper
          modules={[Navigation, Scrollbar, A11y, EffectFade]}
          initialSlide={1}
          spaceBetween={20}
          a11y={{
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide'
          }}
          breakpoints={{
            200: {
              slidesPerView: 1.25
            },
            550: {
              slidesPerView: 1.75
            },
            700: {
              slidesPerView: 2.5
            }
          }}
          pagination={{
            clickable: true
          }}
          centeredSlides={true}
          onSlideChange={(): void => {
            setKillAudio(true)
          }}
          cssMode={isChromeForIOs145()}
        >
          {props.slides.length &&
            props.slides.map(
              (slide: TrackClipSlideType, index: number): React.ReactNode => {
                return (
                  <SwiperSlide key={`track-clip-slider-${index}`}>
                    <TrackClip
                      duration={slide.duration}
                      startTime={slide.startTime}
                      endTime={slide.endTime}
                      mp3Url={slide.mp3Url}
                      title={slide.title}
                      img={slide.img}
                      tags={slide.tags}
                      audioIndex={index}
                      currentAudio={currentAudio}
                      setCurrentAudio={(): void => {
                        setCurrentAudio(index)
                        setKillAudio(false)
                      }}
                      killAudio={killAudio}
                    />
                  </SwiperSlide>
                )
              }
            )}
        </Swiper>
      </MobileSlider>
    </>
  )
}

const MobileSlider = styled.div<any>`
  display: block;
  margin: 40px 0 68px;
  ${(props: any): any => config(props).media.md`
    margin: 45px 0 0px;
  `}
  > .swiper {
    overflow: visible;
  }
  ${(props: any): any => config(props).media.lg`
    display: none;
  `}
`
const DesktopSlider = styled.div<any>`
  display: none;
  ${(props: any): any => config(props).media.lg`
    max-width: 600px;
    width: 100%;
    align-self: center;
    display: flex;
    align-items: center;

  
    > .swiper {
      padding: 0 5px;
      .swiper-wrapper {     
        align-items: center;
      }
    }
  `}
`

const ArrowWrapper = styled.div<any>`
  display: flex;
  justify-content: center;
  will-change: transform;
  transition: transform 0.2s ease;
  transform: translate3d(0px, 0, 0);
  cursor: pointer;

  &.swiper-button-disabled {
    &:hover {
      transform: translate3d(0, 0, 0) !important;
    }
    > svg {
      opacity: 0.8;
    }
  }
  &.slidePrev-btn-track-slider {
    padding: 10px 20px 10px 0;
    &:hover {
      transform: translate3d(-15px, 0, 0);
    }
    &:focus {
      outline: none;
    }
  }
  &.slideNext-btn-track-slider {
    padding: 10px 0 10px 20px;
    &:hover {
      transform: translate3d(15px, 0, 0);
    }
    &:focus {
      outline: none;
    }
  }
`
